import apiHelper from "./apiHelper";
import { Constant } from "./interfaces";
import { message } from "antd";

export const getConstants = async () => {
  const url = "/configure";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  message.error(response.data.message);
  return { error: true };
};

export const postConstants = async (body: Constant) => {
  const url = "/configure";
  const response: any = await apiHelper.post(url, { ...body });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const updateConstants = async (id: string, body: Partial<Constant>) => {
  const url = `/configure/${id}`;
  const response: any = await apiHelper.patch(url, body);
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};
